
import AchSettlementGraph from '../graph/AchSettlementGraph';
import { ContentHeader } from '../layout/ContentHeader';

function AchPage(props: any) {
    return (
        <div>
            <ContentHeader title="ACH" />
            <AchSettlementGraph />
        </div>
    );
}

export default AchPage;
